import {css} from '@emotion/css';
import {negative} from '@fo/shared/styles/mixins/negative';
import {fonts} from '@fo/shared/styles/variables';
import {mq, Breakpoints} from '@fo/shared/styles/mixins/media-queries';
import {colours} from '@fo/shared/styles/variables/colours';
import {spacing} from '@fo/shared/styles/variables/spacing';

const styles = {
  jumpToAnchorMenu: css`
    label: jumpToAnchorMenu;
    position: relative;
    ${mq(Breakpoints.DESKTOP)} {
      position: sticky;
      top: 0;
      z-index: 99;
    }
  `,
  container: css`
    label: jumpToAnchorMenu__container;
    padding: ${spacing.XXS} ${spacing.XS};
    color: ${colours.semantic.INFORMATION};
    ${mq(Breakpoints.DESKTOP)} {
      padding-top: ${spacing.M};
      background-color: transparent;
    }
  `,
  title: css`
    label: jumpToAnchorMenu__title;
    padding: ${spacing.XXS} 0;
    color: ${colours.font.DARK_GRAY};
    font-weight: ${fonts.weight.SEMI_BOLD};
    font-size: 1.7rem;
    line-height: 1;
    outline: none;
    ${mq(Breakpoints.DESKTOP)} {
      padding: 0 ${spacing.XS};
      color: ${colours.font.BLACK};
      text-transform: uppercase;
    }
  `,
  arrow: (isOpen: boolean): string => css`
    label: jumpToAnchorMenu__arrow;
    margin: ${negative(spacing.XXS)};
    transform: rotate(0deg);
    transition: transform 250ms;
    path {
      fill: ${colours.semantic.INFORMATION};
    }
    ${isOpen &&
    css`
      transform: rotate(90deg);
    `}
  `,
  content: (isOpen: boolean): string => css`
    label: jumpToAnchorMenu__content;
    height: 0;
    padding: 0 ${spacing.XS};
    overflow: hidden;
    transition: height 250ms, padding 250ms;

    ${isOpen &&
    css`
      height: auto;
      padding: ${spacing.M} ${spacing.XS};
      ${mq(Breakpoints.DESKTOP)} {
        padding: ${spacing.S} ${spacing.XS} ${spacing.XL} 0rem;
      }
    `}

    .button {
      margin-bottom: ${spacing.XL};
    }
    .trustpilot-widget {
      width: 22rem;
      height: 10rem;
      padding: 0;
    }
  `,
  contentList: css`
    label: jumpToAnchorMenu__contentList;
    margin-bottom: ${spacing.M};
  `,
  contentListItem: css`
    label: jumpToAnchorMenu__contentListItem;
    margin-bottom: ${spacing.XS};
    font-weight: ${fonts.weight.SEMI_BOLD};
    font-size: 1.6rem;
    line-height: 1;
    a,
    a:visited,
    a:hover,
    a:active {
      color: inherit;
      text-decoration: none;
    }
  `,
  contentContainer: css`
    label: jumpToAnchorMenu__contentContainer;
    min-width: auto;
  `,
  afterContent: css`
    label: jumpToAnchorMenu__afterContent;
    top: ${spacing.L};
    ${mq(Breakpoints.DESKTOP)} {
      top: 0;
    }
  `,
};

export default styles;
